<template>
  <div>
    <hg-dialog :title="title" :width="700" :height="400" :visible.sync="show" @close="handleClose">
      <el-form :model="data" size="mini"  :rules="rules" ref="ruleForm" label-width="110px" class="add-box">
        <el-row :gutter="22">
          <el-col :span="22">
            <el-form-item label="上级机构" prop="parentId">
              <organizational-select @handleChange="handleChange" :selectedArr="data.selectedArr" v-if="dialogVisible" selectType="save" :disabled="!isEdit"></organizational-select>
              <!--<el-input v-model="data.parentId" maxlength="50" placeholder="请选择上级机构"></el-input>-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="11">
            <el-form-item label="机构编码" prop="depCode">
              <el-input v-model="data.depCode" maxlength="12" placeholder="请输入机构编码" :disabled="!isEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="机构名称" prop="name">
              <el-input v-model="data.name" maxlength="50" placeholder="请输入机构名称" :disabled="!isEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="11">
            <el-form-item label="机构简称" prop="shortname">
              <el-input v-model="data.shortname" maxlength="50" placeholder="请输入机构简称" :disabled="!isEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系方式1" prop="phone1">
              <el-input v-model="data.phone1" maxlength="11" placeholder="请输入联系方式1" :disabled="!isEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="11">
            <el-form-item label="机构级别" prop="grade">
              <el-select v-model="data.grade" placeholder="请选择机构级别" :disabled="!isEdit">
                <el-option v-for="(item,index) in 9" :key="index" :label="index+1+'级'" :value="index+1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系方式2" prop="phone2">
              <el-input v-model="data.phone2" maxlength="11" placeholder="请输入联系方式2" :disabled="!isEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="11">
            <el-form-item label="排序号" prop="sort">
              <el-input v-model="data.sort" maxlength="8" placeholder="请输入排序号" :disabled="!isEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="查询前缀" prop="before">
              <el-input v-model="data.before" maxlength="50" placeholder="请输入查询前缀" :disabled="!isEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="hg-dialog-footer">
        <el-button v-if="isEdit" type="primary" @click="submit" size="small" icon="el-hg-icon-save">保 存</el-button>
        <el-button v-else type="primary" @click="edit" size="small" icon="el-hg-icon-edit">修 改</el-button>
        <el-button @click="handleClose" size="small" icon="el-hg-icon-close">关 闭</el-button>
      </span>
    </hg-dialog>
  </div>
</template>
<script>
import organizationalSelect from '../../../comm/organizationalSelect';
import HgDialog from '@/components/dialog';

export default {
  name: 'edit',
  components: {
    organizationalSelect,
    HgDialog
  },
  props: {
    data: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    },
    title: {
      String,
      default: '角色详情'
    },
    isEdit: {
      String,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      rules: {
        parentId: [{
          required: true,
          message: '请选择上级部门',
          trigger: 'change'
        }],
        depCode: [{
          required: true,
          message: '请输入机构编码',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入机构名称',
          trigger: 'blur'
        }],
        shortname: [{
          required: true,
          message: '请输入机构简称',
          trigger: 'blur'
        }],
        phone1: [
          {
            required: true,
            message: '请输入联系方式1',
            trigger: 'blur'
          },
          {
            pattern: this.$utils.regRule.phone,
            message: '联系方式格式不正确',
            trigger: 'blur'
          }
        ],
        grade: [{
          required: true,
          message: '请选择机构级别',
          trigger: 'change'
        }],
        sort: [
          {
            required: true,
            message: '请输入排序号',
            trigger: 'blur'
          },
          {
            pattern: this.$utils.regRule.nGInteger,
            message: '排序号格式不正确',
            trigger: 'blur'
          }
        ],
        before: [{
          required: true,
          message: '请输入查询前缀',
          trigger: 'blur'
        }]
      },
      dataForm: {
        parentId: '',
        depCode: '',
        name: '',
        shortname: '',
        phone1: '',
        grade: '',
        phone2: '',
        sort: '',
        before: '',
        updateFlg: 'update'
      }
    };
  },
  methods: {
    edit() {
      this.$emit('update:isEdit', true);
      this.$emit('update:title', '机构编辑');
    },
    submit() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.dataForm.id = this.data.id;
          this.dataForm.parentId = this.data.parentId;
          this.dataForm.depCode = this.data.depCode;
          this.dataForm.name = this.data.name;
          this.dataForm.shortname = this.data.shortname;
          this.dataForm.phone1 = this.data.phone1;
          this.dataForm.grade = this.data.grade;
          this.dataForm.phone2 = this.data.phone2;
          this.dataForm.sort = this.data.sort;
          this.dataForm.before = this.data.before;
          this.dataForm.state = this.data.state;
          this.saveDepart();
        }
        else {
          return false;
        }
      });
    },
    handleChange(arry) {
      this.data.parentId = arry.join(',');
    },

    async saveDepart() {
      const res = await this.$services.postJson({
        type: 'ORGANIZATIONALMANAGEMENT',
        url: 'saveDepart',
        params: JSON.parse(JSON.stringify(this.dataForm))
      });
      if (res.code === '000') {
        this.$toaster.ok('保存成功');
        this.handleClose();
        this.$emit('updateKeyChildren');
      }
      else {
        this.$toaster.error(res.msg);
      }
    },
    handleClose() {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      this.$emit('close');
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
      }
    }
  }
};
</script>
